import classNames from 'classnames'
import useIsMobile from '../../modules/hooks/common/useIsMobile'
import { CDN_URL, COLORS } from '../../modules/vars'

interface SignUpLogoProps {
  type: 'kakao' | 'naver' | 'google' | 'facebook' | 'apple'
  size?: 'sm' | 'lg'
  text?: string
  clx?: string
  dataRef?: string
  disabled?: boolean
  /** default click function */
  onClick?: () => void
  /** additional onclick function e.g data tracking */
  addOnClick?: () => void
}

const SignUpLogoNew = ({ type, size = 'sm', text, clx, dataRef, onClick, addOnClick, ...props }: SignUpLogoProps) => {
  const COLOR_OPTION = {
    kakao: '#ffe900',
    naver: '#04c75a',
    google: COLORS.WHITE,
    facebook: '#0080f9',
    apple: '#000000',
  }

  const LOGO_OPTION = {
    kakao: '/logo/ico-kakaotalk.svg',
    naver: '/logo/ico-naver.svg',
    google: '/logo/ico-google.svg',
    facebook: '/logo/ico-facebook.svg',
    apple: '/logo/ico-apple.svg',
  }

  const ID_OPTION = {
    kakao: 'btn-kakao',
    naver: 'btn-naver',
    google: 'btn-google',
    facebook: 'btn-facebook',
    apple: 'btn-apple',
  }

  const handleOnClick = (defaultOnclick, additionalOnclick) => {
    defaultOnclick && defaultOnclick()
    additionalOnclick && additionalOnclick()
  }

  const isMobile = useIsMobile()

  return (
    <div
      id={ID_OPTION[type]}
      data-ref={dataRef}
      onClick={() => handleOnClick(onClick, addOnClick)}
      style={{
        minWidth: size === 'sm' ? 56 : isMobile ? '100%' : '100%',
        minHeight: 56,
        borderRadius: size === 'sm' ? '50%' : 5,
        backgroundColor: COLOR_OPTION[type],
      }}
      className={classNames(
        clx,
        [type === 'google' && 'border border-gray-300'],
        'flex cursor-pointer items-center justify-center'
      )}
    >
      {type == 'kakao' && size == 'lg' ? (
        <img style={{ width: 18, height: 18 }} src={`${CDN_URL}${LOGO_OPTION[type]}`} />
      ) : (
        <img style={{ width: 30, height: 30 }} src={`${CDN_URL}${LOGO_OPTION[type]}`} />
      )}
      {text && (
        <div
          className={classNames([
            type === 'naver' && 'text-white',
            type === 'kakao' && 'text-black',
            type === 'google' && size != 'lg' && 'text-white',
            type === 'google' && size == 'lg' && 'text-black',
            type === 'facebook' && 'text-white',
            type === 'apple' && 'text-white',
            type == 'kakao' && size == 'lg' ? 'text-h5 ml-[6px] font-medium  leading-[20px]' : 'display-9 ml-[10px]',
          ])}
        >
          {type === 'apple' ? <button {...props}>{text}</button> : <>{text}</>}
        </div>
      )}
    </div>
  )
}

export default SignUpLogoNew
